import { DocumentReference, FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import Assinatura from "../models/assinatura";
import BaseDb from "./baseDb";

export default class AssinaturaDb extends BaseDb<
  Assinatura,
  { usuarioId: string; assinaturaId: string }
> {
  _path: string = "usuarios/usuarioId/subscriptions/assinaturaId";
  getConverter(): FirestoreDataConverter<Assinatura> {
    return {
      fromFirestore: (snapshot, _options) => {
        return {
          id: snapshot.id,
          dataAssinatura: moment(snapshot.get("created").toDate()),
          dataFinalCicloCobranca: moment(
            snapshot.get("current_period_end").toDate()
          ),
          situacao: snapshot.get("status"),
          inicioAvaliacao: snapshot.get("trial_start")
            ? moment(snapshot.get("trial_start").toDate())
            : undefined,
          finalAvaliacao: snapshot.get("trial_end")
            ? moment(snapshot.get("trial_end").toDate())
            : undefined,
          plano: snapshot.get("product") as DocumentReference,
          quantidade: snapshot.get("quantity"),
        } as Assinatura;
      },
      toFirestore: (_assinatura: Assinatura) => {
        return {};
      },
    };
  }
}
